import { Container } from "components/Container";
import config from "config/config";
import { useEffect, useState } from "react";

export const OneTrustCookiesList = () => {
  const isOneTrustEnabled = config.oneTrustEnabled === "enabled";
  const [divId, setDivId] = useState(null);

  useEffect(() => {
    setDivId("ot-sdk-cookie-policy");
    if (window.OneTrust != null) {
      window.OneTrust.Init();
      setTimeout(() => {
        window.OneTrust?.LoadBanner();
      }, 1000);
    }
  }, []);

  if (!isOneTrustEnabled) return null;

  return (
    <Container>
      <div id={divId} />
    </Container>
  );
};
